
import axios from 'axios'

import { Product } from '../../../app-layer/util/typings'

  
const axiosGetFullProductJSON = async (handle: string): Promise<Product|void> => {
  try {
    const {data} = await axios.get(`/products/${handle}.js`);
    return data
  } catch (e) {
    console.info(e)
  }
}

export default axiosGetFullProductJSON
